import CTAButton from './Button.client'

export default CTAButton
